import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getOrderList } from '../../api/orderHistory';
import { getGuestRecentProducts, getLikeProducts, getMyReview, getRecentProducts } from '../../api/product';
import { useCommonContext } from '../provider/CommonProvider';

interface propsType {
  item?: any;
}

export default function MyShoppingSideBar({ item }: propsType) {
  const [recentCount, setRecentCount] = useState<number>(0);
  const [wishCount, setWishCount] = useState<number>(0);
  const [orderCount, setOrderCount] = useState<number>(0);
  const [reviewCount, setReviewCount] = useState<number>(0);
  const { hasAccessToken } = useCommonContext();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const setCount = (count: any) => setRecentCount(count);

    const fetchRecentProducts = async () => {
      if (hasAccessToken) {
        try {
          const res = await getRecentProducts(1);
          const filteredProducts = res.data.filter((el: any) => !el.displayCategoryNos.includes('787334'));
          setCount(filteredProducts.length);
        } catch (err) {
          console.log(err);
        }
      } else if (window) {
        const product = window.sessionStorage.getItem('mallProductNo');
        if (product) {
          const productParse = JSON.parse(product);
          if (productParse.length) {
            try {
              const res = await getGuestRecentProducts(productParse);
              setCount(res.data.length);
            } catch (err) {
              console.log(err);
            }
          }
        }
      }
    };

    const filterItemProducts = () => {
      if (item) {
        const filteredItems = item.filter((el: any) => !el.displayCategoryNos.includes('787334'));
        setCount(filteredItems.length);
      }
    };

    if (!location.pathname.includes('/recentView') && !isMobile) {
      fetchRecentProducts();
    } else {
      filterItemProducts();
    }
  }, [item, isMobile, hasAccessToken]);
  useEffect(() => {
    const fetchLikeProducts = async () => {
      if (hasAccessToken && !isMobile) {
        try {
          const res = await getLikeProducts(1);
          const filteredItems = res.data.items.filter((el: any) => !el.displayCategoryNos?.includes('787334'));
          setWishCount(filteredItems.length);
        } catch (err) {
          console.log(err);
        }
      }
    };

    fetchLikeProducts();
  }, [hasAccessToken, isMobile]);

  useEffect(() => {
    const fetchOrderList = async () => {
      if (hasAccessToken) {
        try {
          const res = await getOrderList();
          const items = res.data.items || []; // items가 없을 경우를 대비한 기본값 설정
          const totalOrderCount = items.length;

          setOrderCount(totalOrderCount);
        } catch (err) {
          console.log(err);
        }
      }
    };

    fetchOrderList();
  }, [hasAccessToken]);

  useEffect(() => {
    if (hasAccessToken && !isMobile) {
      getMyReview()
        .then((res) => {
          setReviewCount(res.data.totalCount);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [hasAccessToken]);

  return (
    <div className="myshopping_sidemenu">
      {/* 계정정보 */}
      <h3>계정정보</h3>
      <ul>
        {hasAccessToken && (
          <>
            <li>
              <Link to="/profile">프로필 편집</Link>
            </li>
            <li>
              <Link to="/coindetail">피싱코인 내역</Link>
            </li>
            <li>
              <Link to="/accumulation">적립금 내역</Link>
            </li>
          </>
        )}
        <li>
          <Link to="/recentView">
            최근 본 상품 <span>{recentCount}</span>
          </Link>
        </li>
        <li>
          <a
            onClick={() => {
              if (hasAccessToken) {
                navigate(`/orderlistinquiry`);
              } else {
                navigate(`/guestorderlist`);
              }
            }}
          >
            주문 내역
            {orderCount !== 0 ? <span>{orderCount}</span> : <span>0</span>}
          </a>
        </li>
        {hasAccessToken ? (
          <>
            <li>
              <Link to="/wishList">
                찜한 목록 <span>{wishCount}</span>
              </Link>
            </li>
            <li>
              <Link to="/mycoupon">마이 쿠폰</Link>
            </li>
            <li>
              <Link to="/coupon">쿠폰 받기</Link>
            </li>
            <li>
              <Link to="/reviewlist/prepare">
                상품 리뷰 <span>{reviewCount}</span>
              </Link>
            </li>
            <li>
              <Link to="/pushSetting">푸시알림 설정</Link>
            </li>
          </>
        ) : null}
      </ul>

      {/* 고객센터 */}
      <h3>고객센터</h3>
      <ul className="customer_center">
        {hasAccessToken && (
          <>
            <li>
              <Link to="/productQnaList">상품 Q&amp;A</Link>
            </li>

            <li>
              <Link to="/inquiryList">1:1 문의</Link>
            </li>
          </>
        )}
        <li>
          <Link to="/noticeList">공지사항</Link>
        </li>
        <li>
          <Link to="/faqList">자주 묻는 질문</Link>
        </li>
        {/* <li>
          <Link to='/benefit'>혜택 소개</Link>
        </li> */}
      </ul>
    </div>
  );
}
